import React, { useState, useEffect } from "react";
import {
    Button,
    colors,
    Container,
    Dialog,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { uri } from "../../../../../help/Api";
import { useHistory } from "react-router-dom";
import {
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import moment from "moment";
import axios from "axios";
import { sto } from "../../../../../Context/InshData";
import ReplyIcon from "@material-ui/icons/Reply";
import SarfTwreedSearchForm from "./SarfTwreedSearchForm";
import SarfTwreedSearchTable from "./SarfTwreedSearchTable";
import { GetItemFromOptions } from "../../../../../services/global-services";
import TotalCard from "../../../../../components/TotalCard";
import { CSVLink } from "react-csv";
import { TableChart } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
}));

export default function SarfTwreedSearch(props) {
    const {
        handOpenDw,
        TransitionUp,
        setPrevent,
        openDw,
        transition,
        handCloseDw,
        getSearchHeadData,
        setEstelamAfter,
        SafesOptions,
        IsSarf,
        SafesEmp,
        AutoOptions
    } = props;
    const [branches, setBranches] = useState(() => {
        return [{ id: -1, name: "الكل" }, ...AutoOptions?.Branches];
    });
    const valuebranch = GetItemFromOptions(sto.branchi, AutoOptions.Branches ?? []);

    const initialSearchObject = {
        dateFrom: moment(new Date()).format('YYYY-MM-DD'),
        timeFrom: moment(new Date()).startOf("day").format("HH:mm"),
        dateTo: moment(new Date()).format('YYYY-MM-DD'),
        timeTo: moment(new Date()).format('HH:mm'),
        branch: sto.User_typei == 1 ? branches[0] : valuebranch,
        refno: '',
        no: '',
        type: IsSarf ? 2 : 1,
        transfer_no: '',
        user: { id: -1, name: "الكل" },
        safe: sto.User_typei == 1 ? { id: -1, name: "الكل" } : SafesEmp[0],

    };

    const [rptParams, setRptParams] = React.useState(initialSearchObject);
    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const { t } = useTranslation(["forms", "translation"]);

    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const viewHandle = async () => {
        setData([]);
        setFetching(true);
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
            Urls = `RptSafes/TwreedSarfSearch?branch=${rptParams?.branch.id}&&trans_no=${rptParams?.no}
            &&fDate=${rptParams.dateFrom + ' ' + rptParams.timeFrom}&&tDate=${rptParams.dateTo + ' ' + rptParams.timeTo}
            &&refno=${rptParams?.refno}&&type=${rptParams?.type}&&safe=${rptParams.safe?.id}`
        } else {
            Urls = `RptSafes/TwreedSarfSearch?branch=${rptParams?.branch.id}&&trans_no=${rptParams?.no}
            &&fDate=${rptParams.dateFrom + ' ' + rptParams.timeFrom}&&tDate=${rptParams.dateTo + ' ' + rptParams.timeTo}
            &&refno=${rptParams?.refno}&&type=${rptParams?.type}&&safe=${rptParams.safe?.id}}
            &&db_name=${sto.db_name}`
        }
        await axios
            .get(
                uri + Urls
            )
            .then((res) => {
                setData(res.data);
                console.log(" the data is", res.data);
                setFetching(false);
            })
            .catch((err) => {
                setFetching(false);
                console.log(err);
                setData([]);
            });
    };
    const his = useHistory();

    const excel_name = IsSarf ? "SarfReoprts" : "TwareedReports";

    const excelHeaders = [
        { label: "رقم الامر", key: "no", },
        { label: "التاريخ", key: "date", },
        { label: "الوقت", key: "time", },
        { label: "المخزن", key: "safeName", },
        { label: "البيان", key: "notes", },
        { label: "مركز التكلفة", key: "centerName", },
        { label: "Quantity Total", key: "tot_val", },
        { label: "Total Amount", key: "tot_amount", },
    ];

    const changTField = (prop) => (e) => {
        setRptParams({ ...rptParams, [prop]: e.target.value });
    };
    const onChangeData = (propName) => (event) => {
        setRptParams({ ...rptParams, [propName]: event.target.value });
    };
    const onChangeAutoData = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue });
    };
    return (
        <Dialog
            fullScreen
            open={openDw}
            onClose={handOpenDw}
            TransitionComponent={transition}
            key={transition ? transition.name : ""}
        >
            <div className={classes.root}>
                <Grid container item xs={12}>
                    <Typography
                        size="small"
                        className={classes.headerTitle}
                        color="primary"
                    >
                        {IsSarf ? "البحث في أمر الصرف المخزني" : "البحث في أمر التوريد المخزني"}
                    </Typography>
                </Grid>
                <Typography
                    component="div"
                    style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
                >
                    <Container
                        component={Paper}
                        maxWidth={false}
                        style={{
                            padding: "10px",
                            paddingBottom: "0px",
                            borderBottomColor: colors.blue[500],
                            borderBottomWidth: "1px",
                            borderBottomStyle: "solid",
                        }}
                    >
                        <SarfTwreedSearchForm
                            {...{
                                rptParams,
                                onChangeData,
                                changTField,
                                onChangeAutoData,
                                SafesOptions,
                                SafesEmp,
                                AutoOptions,
                                branches
                            }}
                        />
                        <Grid
                            container
                            justifyContent="center"
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            spacing={1}
                        >
                            <Hidden smUp>
                                <Grid item>
                                    <Button
                                        disabled={fetching}
                                        variant="contained"
                                        startIcon={<ScannerIcon />}
                                        size="large"
                                        style={
                                            (inshst.sal.iconBtn,
                                                { borderRadius: 0 })
                                        }
                                        className={[clasui.button]}
                                        onClick={() => viewHandle()}
                                    >
                                        {t("forms:show")}
                                    </Button>
                                </Grid>
                            </Hidden>

                            <Hidden only={"xs"}>
                                <Grid item>
                                    <Button
                                        disabled={fetching}
                                        variant="contained"
                                        startIcon={<ScannerIcon />}
                                        size="large"
                                        style={
                                            (inshst.sal.iconBtn,
                                                { borderRadius: 0 })
                                        }
                                        className={[clasui.button]}
                                        onClick={() => viewHandle()}
                                    >
                                        {t("forms:view")}
                                    </Button>
                                </Grid>
                            </Hidden>
                            <Grid item >
                                {data && !fetching && data.twreedSarfData && (
                                    <CSVLink
                                        separator={";"}
                                        filename={excel_name}
                                        data={data.twreedSarfData}
                                        headers={excelHeaders}
                                    >
                                        <Button
                                            disabled={fetching}
                                            variant="contained"
                                            startIcon={<TableChart />}
                                            size="large"
                                            color="primary"
                                            style={{ borderRadius: 0 }}
                                            className={[clasui.button]}
                                        >
                                            {t("excel_export")}{" "}
                                        </Button>
                                    </CSVLink>
                                )}
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    startIcon={<ReplyIcon />}
                                    color="secondary"
                                    size="large"
                                    aria-label="open drawer"
                                    className={[clasui.button, clasSp.clcan]}
                                    style={
                                        (inshst.sal.iconBtn,
                                            { borderRadius: 0 })
                                    }
                                    onClick={() => handCloseDw()}
                                >
                                    {/* {t("forms:exit")} */}
                                    {"رجوع"}
                                </Button>
                            </Grid>
                        </Grid>
                    </Container>
                    <Container maxWidth={true} style={{ padding: "4px", marginTop: "0.3rem" }}>
                        <Grid container spacing={1} style={{ paddingTop: "10px" }}>
                            <Grid item lg={2} md={2} sm={4} xs={6}>
                                <TotalCard
                                    {...{
                                        className: classes.purchTotalCard,
                                        title: "اجمالي الكميات",
                                        value: data?.twreedSarfData?.reduce((a, v) => (a = a + parseFloat(v?.tot_val ?? 0)), 0).toFixed(2),
                                    }}
                                />
                            </Grid>
                            <Grid item lg={2} md={2} sm={4} xs={6}>
                                <TotalCard
                                    {...{
                                        className: classes.purchTotalCard,
                                        title: "اجمالي المبلغ",
                                        value: data?.twreedSarfData?.reduce((a, v) => (a = a + parseFloat(v?.tot_amount ?? 0)), 0).toFixed(2),
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Container>
                    {/* <br /> */}
                    <Container
                        component={Paper}
                        maxWidth={false}
                        style={{
                            paddingRight: "5px",
                            paddingLeft: "5px",
                        }}
                    >
                        <Grid container justifyContent="center">
                            <Grid item container justifyContent="center" xs={12}>
                                <BeatLoader loading={fetching} color={colors.blue[300]} />
                                {!fetching && (
                                    <SarfTwreedSearchTable
                                        {...{
                                            data: data?.twreedSarfData ? data.twreedSarfData : [],
                                            setPrevent, handCloseDw, getSearchHeadData,
                                        }}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </Container>
                </Typography>
            </div>
        </Dialog>
    );
}
